// TODO: MNS-2360 - Can be removed after the entire create order form is migrated to React.
import { AddClientTeamMemberModal } from './AddClientTeamMemberModal'

export default AddClientTeamMemberModal
